import React, { useState } from "react";
import { motion } from "framer-motion";
import { useMediaQuery } from "@mui/material";
import "../App.css";
import teamImg from "../images/team.jpg";
import warehouseImg from "../images/warehouse.jpg";
import truckFleetImg from "../images/feelt.jpg";
import bgImage from "../images/redT.jpg";

const About = () => {
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery("(max-width:900px)"); // detect mobile/tablet

  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 },
  };

  // ✅ Move these OUTSIDE return
  const fullText = `Since its inception in 1997, Mangalmurti Transport has
  been a trusted leader in temperature-controlled logistics across India.
  With nearly three decades of expertise, we specialize in ensuring the
  safe, reliable, and efficient movement of goods that require precise
  handling and preservation. Our extensive logistics network connects major
  cities and remote destinations across the country, serving 1000+ retail
  and distribution outlets with unmatched consistency. Backed by
  state-of-the-art infrastructure, advanced fleet technology, and expert
  logistics management, we deliver solutions that uphold the highest
  standards of quality and reliability. At Mangalmurti Transport, we don’t
  just move goods—we build enduring partnerships by offering timely
  deliveries, customized solutions, and uncompromised service quality. Our
  commitment to innovation and customer satisfaction has made us a preferred
  logistics partner for businesses across industries.`;

  const shortText = fullText.slice(0, 250) + "..."; // show preview on mobile

  const infoCards = [
    {
      title: "Our Mission",
      desc: "To consistently exceed customer expectations by delivering reliable, efficient, and innovative logistics solutions that enhance operational performance and support business goals.",
      icon: "🎯",
    },
    {
      title: "Our Vision",
      desc: "To be the most trusted supply chain partner by delivering innovative, technology-driven logistics solutions that empower businesses for exceptional outcomes.",
      icon: "🚀",
    },
    {
      title: "Our Expertise",
      desc: "Frozen & Cold Chain Logistics, Pharmaceutical Supply Transport, FMCG & Retail Distribution, Industrial Goods Support, and Customized Truckload Solutions.",
      icon: "🧊",
    },
    {
      title: "Why Choose Us?",
      desc: "24/7 tracking, temperature-controlled fleet, on-time delivery, expert team, and service coverage in 15+ major cities across India.",
      icon: "✅",
    },
  ];

  return (
    <section
      id="about-us"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "80px 20px",
        position: "relative",
        zIndex: 1,
        color: "#fff",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.7)",
          zIndex: -1,
        }}
      ></div>

      {/* About Text */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        variants={fadeInUp}
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <h2 style={{ fontSize: "2.8rem", marginBottom: "20px" }}>
          About Mangalmurti Transport
        </h2>

        <p
          style={{
            fontSize: "1.1rem",
            lineHeight: 1.8,
            marginBottom: "20px",
          }}
        >
          {isMobile ? (expanded ? fullText : shortText) : fullText}
        </p>

        {isMobile && (
          <button
            onClick={() => setExpanded(!expanded)}
            style={{
              background: "linear-gradient(90deg, #ff5b1f, #ff8146)",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {expanded ? "Read Less" : "Read More"}
          </button>
        )}
      </motion.div>

      {/* Info Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", // flexible grid
          gap: "15px",
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "20px",
        }}
      >
        {infoCards.map((card, index) => (
          <motion.div
            key={index}
            variants={fadeInUp}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
            style={{
              background: "rgba(255,255,255,0.1)",
              backdropFilter: "blur(8px)",
              borderRadius: "10px",
              padding: "15px",
              boxShadow: "0 3px 10px rgba(0,0,0,0.25)",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: "1.8rem", marginBottom: "10px" }}>
              {card.icon}
            </div>
            <h4 style={{ fontSize: "1.1rem", marginBottom: "6px" }}>
              {card.title}
            </h4>
            <p style={{ fontSize: "0.9rem", lineHeight: 1.4 }}>{card.desc}</p>
          </motion.div>
        ))}
      </div>

      {/* Gallery */}
      <motion.div
        style={{
          marginTop: "60px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
        }}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          visible: { transition: { staggerChildren: 0.2 } },
        }}
      >
        {[teamImg, warehouseImg, truckFleetImg].map((img, idx) => (
          <motion.img
            key={idx}
            src={img}
            alt={`Gallery ${idx + 1}`}
            variants={fadeInUp}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
            style={{
              width: "300px",
              height: "200px",
              objectFit: "cover",
              borderRadius: "10px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            }}
          />
        ))}
      </motion.div>
    </section>
  );
};

export default About;
